var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fm-content d-flex flex-column"},[_c('disk-list',{attrs:{"manager":_vm.manager}}),_vm._v(" "),_c('breadcrumb',{attrs:{"manager":_vm.manager}}),_vm._v(" "),_c('div',{staticClass:"fm-content-body"},[(_vm.viewType === 'table')?_c('table-view',{attrs:{"manager":_vm.manager}}):_c('grid-view',{attrs:{"manager":_vm.manager}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }